/** Landing page **/
import ForumsIcon from './forums-icon.png';
import EventsIcon from './events-icon.png';
import LearningIcon from './learning-icon.png';
import HeroGALeftCluster from './hero-ga-left-cluster.png';
import HeroGARightCluster from './hero-ga-right-cluster.png';
import HeroGAMobileTopCluster from './hero-ga-mobile-top-cluster.png';
import HeroGAMobileBottomCluster from './hero-ga-mobile-bottom-cluster.png';
import HeroLeftScribble from './hero-left-scribble.png';
import HeroRightScribble from './hero-right-scribble.png';
import HeroDesktopIcons from './hero-desktop-icons.png';
import HeroTabletIcons from './hero-tablet-icons.png';
import HeroMobileIcons from './hero-mobile-icons.png';
import ForumsContent from './forums-content.svg';
import LearningImage from './learning-image.png';
import ForumsQuestionLeft from './forums-question-left.svg';
import ForumsQuestionRight from './forums-question-right.svg';
import JiraLogoMark from './jira-logo-mark.svg';
import RovoLogoMark from './rovo-logo-mark.svg';
import LearningIllustration from './learning-illustration.png';

/** Events page **/
import EventsHeroArtworkLeftDesktop from './events-hero-artwork-left-desktop.svg';
import EventsHeroArtworkLeftMobile from './events-hero-artwork-left-mobile.svg';
import EventsHeroArtworkLeftTablet from './events-hero-artwork-left-tablet.svg';
import EventsHeroArtworkRightDesktop from './events-hero-artwork-right-desktop.svg';
import CommunityLedClasses from './events-images/events-for-everyone/community-led-classes.svg';
import CompanyUserGroups from './events-images/events-for-everyone/company-user-groups.svg';
import DeveloperEvents from './events-images/events-for-everyone/developer-events.svg';
import LocalMeetups from './events-images/events-for-everyone/local-meetups.svg';
import Discounts from './events-images/get-involved/discounts.svg';
import Flags from './events-images/get-involved/flags.svg';
import InsideScoop from './events-images/get-involved/inside-scoop.svg';
import Networking from './events-images/get-involved/networking.svg';
import NewSkills from './events-images/get-involved/new-skills.svg';
import Swag from './events-images/get-involved/swag.svg';
import ReadyToGetInvolved from './events-images/ready-to-get-involved.svg';

import EventsHeroArtworkRightMobile from './events-hero-artwork-right-mobile.png';
import EventsHeroArtworkRightTablet from './events-hero-artwork-right-tablet.png';

/** Miscellaneous **/
import AtlassianLogoFull from './atlassian-logo-full.svg';
import DangerTriangle from './danger-triangle.svg';
import FooterBackground from './footer-background.png';
import Gesture from './gesture.svg';
import WelcomeModalCoverImage from './welcome-image.png';
import AceLogo from './ace-logo.svg';

export {
  /** Landing page **/
  ForumsIcon,
  EventsIcon,
  LearningIcon,
  HeroGALeftCluster,
  HeroGARightCluster,
  HeroGAMobileTopCluster,
  HeroGAMobileBottomCluster,
  HeroLeftScribble,
  HeroRightScribble,
  HeroDesktopIcons,
  HeroTabletIcons,
  HeroMobileIcons,
  ForumsContent,
  LearningImage,
  ForumsQuestionLeft,
  ForumsQuestionRight,
  JiraLogoMark,
  RovoLogoMark,
  LearningIllustration,
  /** Events page **/
  EventsHeroArtworkLeftDesktop,
  EventsHeroArtworkLeftMobile,
  EventsHeroArtworkLeftTablet,
  EventsHeroArtworkRightDesktop,
  CommunityLedClasses,
  CompanyUserGroups,
  DeveloperEvents,
  LocalMeetups,
  Discounts,
  Flags,
  InsideScoop,
  Networking,
  NewSkills,
  Swag,
  ReadyToGetInvolved,
  EventsHeroArtworkRightMobile,
  EventsHeroArtworkRightTablet,
  /** Miscellaneous **/
  AtlassianLogoFull,
  DangerTriangle,
  FooterBackground,
  Gesture,
  WelcomeModalCoverImage,
  AceLogo,
};
